export default {"src":"/_next/static/media/card-library.a4e4eba9.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};